import type { ChecklistAttrs, ChecklistItem } from './checklist.types';
import { parseDataAttrs } from '@/shared/helpers/parseDataAttrs';

export const parseChecklistProps = (properties: Record<string, any>) =>
  parseDataAttrs<ChecklistAttrs>(properties, {
    ls: '',
    items: '',
  });

/** Safely parse items JSON string */
export const safeParseItems = (raw?: string): ChecklistItem[] => {
  try {
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
